import { render, staticRenderFns } from "./LocalWebcam.vue?vue&type=template&id=2457286a&scoped=true&"
import script from "./LocalWebcam.vue?vue&type=script&lang=js&"
export * from "./LocalWebcam.vue?vue&type=script&lang=js&"
import style0 from "./LocalWebcam.vue?vue&type=style&index=0&id=2457286a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457286a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VIcon,VProgressCircular,VProgressLinear})
